import { IconButton, Stack } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { LegislationLibraryFolderPath } from "./legislation-library-folder-path"

const KIND_ICONS = {
    add: { icon: "mdi:plus-circle-outline", color: "success.main" },
    remove: { icon: "mdi:minus-circle-outline", color: "error.main" },
}

const UNDO_BUTTON_CLASS = "legislation-folder-change-row-undo"

export function LegislationLibraryFolderChangeRow({ item }) {
    const { kind, onToggle, getPath } = useBoundContext()
    const { icon, color } = KIND_ICONS[kind]

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            data-cy="legislation-folder-change-row"
            sx={{
                px: 0.5,
                borderRadius: 1,
                "&:hover": { bgcolor: "action.hover" },
                [`&:hover .${UNDO_BUTTON_CLASS}, &:focus-within .${UNDO_BUTTON_CLASS}`]: { opacity: 1 },
            }}
        >
            <Iconify icon={icon} sx={{ color, fontSize: 18, flexShrink: 0 }} />
            <Stack sx={{ flex: 1, minWidth: 0 }}>
                <LegislationLibraryFolderPath item={getPath(item.id)} />
            </Stack>
            <IconButton
                size="small"
                onClick={() => onToggle(item)}
                aria-label="Undo"
                className={UNDO_BUTTON_CLASS}
                sx={{ opacity: 0 }}
            >
                <Iconify icon="mdi:close" sx={{ fontSize: 16 }} />
            </IconButton>
        </Stack>
    )
}
